import React from "react";
import { Image, Typography } from "antd";
import Emptychat from "../../../assets/doctorIcons/emptychat.svg";

const EmptyChat = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        minHeight: 0,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 16,
        }}
      >
        {/* Placeholder chat bubbles */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            width: 200,
          }}
        >
          <Image src={Emptychat} alt="Empty chat" preview={false} width={250} />
        </div>

        <Typography.Text
          style={{
            color: "#535862",
            fontSize: 20,
            marginTop: 4,
            fontWeight: 600,
          }}
        >
          Pick a chat from left menu
        </Typography.Text>
      </div>
    </div>
  );
};

export default EmptyChat;
